export default __webpack_public_path__ + "static/media/criazi-footer.081af805.png";